import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, ResponseResult } from 'vnpost-shared';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SaleAssociateService extends BaseService  {
  constructor(http: HttpClient, injector: Injector) {
    super(http, injector, `${environment.apiDomain.llbJavaEndpoint}/salesAssociate`);
  }

  getListSalesAssociate(model): Promise<any> {
    const apiUrl = `${this.serviceUri}/getAll`;
    return this._http.post<any>(apiUrl, model)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  getSalesAssociateDetail(id: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/detail/${id}`;
    return this._http.get<any>(apiUrl)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  generateSalesAssociateCode(unitCode: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/generateSalesAssociateCode?unitCode=${unitCode ?? ''}`;
    return this._http.get<any>(apiUrl, {})
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  create(model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/create`;
    return this._http.post<any>(apiUrl, model)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  update(id: any, model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/update/${id}`;
    return this._http.put<any>(apiUrl, model)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  importFile(file: FormData): Promise<any> {
    const apiUrl = `${this.serviceUri}/batchCreate`;
    return this._http
      .post<any>(apiUrl, file)
      // .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
}